import { gql } from '@apollo/client';
import { getFeatureFlags } from 'core/userContext';
import { useSelector } from 'react-redux';
import { useGraphql } from 'utils/hooks/useGraphql';

export const fetchTemplateSingleContentByIdQuery = gql`
  query fetchTemplateSingleContentByIdQuery($id: Long!, $locale: TemplateLocaleInput) {
    templateAndSingleContent(id: $id, locale: $locale) {
      __typename
      ... on TemplateAndContent {
        primaryContent {
          ... on EmailContentDefinition {
            contentId: emailContentId
          }
          ... on InAppContentDefinition {
            contentId: inAppContentId
          }
          ... on PushContentDefinition {
            contentId: pushContentId
          }
          ... on SMSContentDefinition {
            contentId: smsContentId
          }
          ... on WebPushContentDefinition {
            contentId: webPushContentId
          }
        }
      }
      ... on CorruptedTemplateData {
        contentId
      }
    }
  }
`;

/**
 * Fetches the default template and content by template id when the `LocaleImprovements` feature flag is enabled
 */
export const useTemplateSingleContentById = (templateId: number) => {
  const { LocaleImprovements } = useSelector(getFeatureFlags);

  const { data: content = {} } = useGraphql(fetchTemplateSingleContentByIdQuery, {
    skip: !LocaleImprovements || (LocaleImprovements && !templateId),
    variables: {
      id: templateId,
    },
  });

  return {
    templateAndSingleContent: content?.templateAndSingleContent,
  };
};
